import React from "react";
import { Billing } from "../modules//Billing";

export function BillingPage(props) {
  return <Billing {...props} />;
}
